import { render, staticRenderFns } from "./SettingsEmail.vue?vue&type=template&id=870f9c66&scoped=true"
import script from "./SettingsEmail.vue?vue&type=script&lang=js"
export * from "./SettingsEmail.vue?vue&type=script&lang=js"
import style0 from "./SettingsEmail.vue?vue&type=style&index=0&id=870f9c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870f9c66",
  null
  
)

export default component.exports